module.exports = __webpack_public_path__ + "img/document.f9bdc9bb.svg";